const DrawerRoute = () => ({});

export default DrawerRoute;
